const messages = state => state.messages;

export default {
  messages,
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js